import OversightPermissionManager from "./OversightPermissionManager"

export default function OversightPermissions() {
  return (
    <div style={{ padding: 24 }}>
      <h2>User Oversight Permissions</h2>
      <OversightPermissionManager />
    </div>
  )
}
